import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Popover, PopoverBody } from 'reactstrap'; // eslint-disable-line no-restricted-imports
import { PriceDropAlerts } from 'site-modules/shared/components/profile/price-drop-alerts/price-drop-alerts';
import { PriceDropAlertsList } from 'site-modules/shared/components/profile/price-drop-alerts-list/price-drop-alerts-list';

import './price-drop-alerts-popover.scss';

export function PriceDropAlertsPopover({ showAlerts = false, isGlobalNavDesktop = false, use2027Theme = false }) {
  const [isPopoverOpen, setPopoverOpen] = useState(false);

  const popoverRef = useRef();
  const btnRef = useRef();

  function toggle(event) {
    if (event && event.currentTarget === popoverRef.current) {
      // exit by Esc keyboard
      btnRef.current.focus();
    }
    setPopoverOpen(!isPopoverOpen);
  }

  function close() {
    btnRef.current.focus();
    setPopoverOpen(!isPopoverOpen);
  }

  useEffect(() => {
    function handleDocumentFocus(event) {
      const element = event.target;
      const subtreeRoot = popoverRef.current;
      const isInDOMSubtree = subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
      if (element !== btnRef.current && isPopoverOpen && !isInDOMSubtree) {
        setPopoverOpen(!isPopoverOpen);
      }
    }
    if (isPopoverOpen) {
      popoverRef.current.setAttribute('role', 'dialog');
      popoverRef.current.setAttribute('aria-hidden', false);
      popoverRef.current.focus();
      document.addEventListener('focus', handleDocumentFocus, true);
    }

    return () => {
      if (isPopoverOpen) {
        document.removeEventListener('focus', handleDocumentFocus, true);
      }
    };
  }, [isPopoverOpen]);

  return (
    <li className="insider-notifications-container">
      <button
        id="insider-notifications-btn"
        className={classNames('pos-r btn-link nav-link px-0_5 px-md-1', {
          'me-0_5': !isGlobalNavDesktop,
          'me-0': isGlobalNavDesktop,
          'text-shadow-contrast': !use2027Theme,
        })}
        disabled={showAlerts === null}
        title="Open My notifications"
        aria-label="Open My notifications"
        aria-haspopup="true"
        aria-expanded={isPopoverOpen}
        ref={btnRef}
      >
        <span
          className={classNames('insider-icon icon-bell2', {
            'text-white': !use2027Theme,
            'text-cool-gray-10': use2027Theme,
          })}
          aria-hidden
        />
        {showAlerts && <PriceDropAlerts hideAlertsPerSession={isPopoverOpen} className="ms-0_5" />}
      </button>
      <Popover
        placement="bottom"
        target="insider-notifications-btn"
        isOpen={isPopoverOpen}
        toggle={toggle}
        container=".insider-notifications-container"
        innerRef={popoverRef}
        tabIndex={-1}
        aria-labelledby="price-drop-header"
        trigger="legacy"
      >
        <PopoverBody className="px-1 py-1 pos-r">
          <PriceDropAlertsList showAlerts={showAlerts} />
          <div className="close-wrapper pos-a">
            <button
              onClick={close}
              aria-label="Close notifications"
              title="Close notifications"
              className="btn btn-close visually-hidden-focusable"
            >
              <span className="icon-cross3" aria-hidden />
            </button>
          </div>
        </PopoverBody>
      </Popover>
    </li>
  );
}

PriceDropAlertsPopover.propTypes = {
  showAlerts: PropTypes.bool,
  isGlobalNavDesktop: PropTypes.bool,
  use2027Theme: PropTypes.bool,
};
